import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private http:HttpClient, private sharedapi:SharedService) {}

  addOpdFeedback(data)
  { 
      var formData: any = new FormData();
      for (const key in data) 
      { 
        if((key=='followupdate') && data[key] != null)
        {
            formData.append(key, data[key].getFullYear()+'-'+(data[key].getMonth()+1)+'-'+data[key].getDate());
        }else
            formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-opd-feedback',formData,{headers:webheader})
  }

  getOpdfeedbackDetails(data){
    let opd_id = data.opd_id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-opd-feedback-details/'+opd_id,{headers:webheader})

  }

  getIpdfeedbackDetails(data){
    let ipd_id = data.ipd_id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-ipd-feedback-details/'+ipd_id,{headers:webheader})

  }

  updateOpdfeeback(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-opd-feedback-data',data,{headers:webheader})
  }

  addIpdFeedback(data)
  { 
      /* console.log(data); */
      var formData: any = new FormData();
  	  for (const key in data) 
      { 
        /* formData.append(key, data[key]); */
        if((key=='followupdate') && data[key] != null)
        {
            formData.append(key, data[key].getFullYear()+'-'+(data[key].getMonth()+1)+'-'+data[key].getDate());
        }else
            formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-ipd-feedback',formData,{headers:webheader})
  }

  check_feedback_slug(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'check-ipd-feedback-slug',data,{headers:webheader})
  }

  updateIpdfeeback(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-ipd-feedback-data',data,{headers:webheader})
  }

  getOpdsIpdsFeedbacks(pageno,limit,qstring,type)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-opds-ipds-feedbacks/'+type +'/' +limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  deletefeedback_files(ipd_id, file_type)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delete-ipd-feedback-files/'+ipd_id+'/'+file_type,{headers:webheader})
  }
  deleteOpdfeedback_files(opd_id, file_type)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delete-opd-feedback-files/'+opd_id+'/'+file_type,{headers:webheader})
  }
  
}
